module.exports = __webpack_public_path__ + "img/1.0d5b0dda.webp";